import * as routeNames from 'constants/routeNames';
import PreconditionsInfo from './PreconditionsInfo';

export default {
  [routeNames.PRECONDITIONS_INFO]: {
    screen: PreconditionsInfo,
  },
};
